import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Assessment from "./pages/Assessment";
import OperatorWalk from "./pages/OperatorWalk";
import AdminLogin from "./pages/AdminLogin";
import { PortalAuthProvider } from "./lib/portalAuth";
import { PricingProvider } from "./lib/pricing";
import { ContentProvider } from "./lib/content";
import PortalProtectedRoute from "./components/PortalProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import PortalLogin from "./pages/PortalLogin";
import PortalForgot from "./pages/PortalForgot";
import PortalReset from "./pages/PortalReset";
import PortalDashboard from "./pages/PortalDashboard";
import ShareReport from "./pages/ShareReport";
// Unified admin
import AdminHome from "./pages/admin/AdminHome";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminContact from "./pages/admin/AdminContact";
import AdminCareers from "./pages/admin/AdminCareers";
import AdminAssessmentsPage from "./pages/admin/AdminAssessmentsPage";
import AdminOperatorWalkPage from "./pages/admin/AdminOperatorWalkPage";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminContent from "./pages/admin/AdminContent";
import AdminPricing from "./pages/AdminPricing";

// Wraps an admin page so only authenticated admin users can reach it.
const Admin = ({ children }) => (
  <PortalProtectedRoute role="admin">{children}</PortalProtectedRoute>
);

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <PortalAuthProvider>
          <PricingProvider>
          <ContentProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/operator-walk" element={<OperatorWalk />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/assessment" element={<Assessment />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/careers" element={<Careers />} />
              </Route>

              {/* Unified admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin><AdminHome /></Admin>} />
              <Route path="/admin/blog" element={<Admin><AdminBlog /></Admin>} />
              <Route path="/admin/contact" element={<Admin><AdminContact /></Admin>} />
              <Route path="/admin/careers" element={<Admin><AdminCareers /></Admin>} />
              <Route path="/admin/assessments" element={<Admin><AdminAssessmentsPage /></Admin>} />
              <Route path="/admin/operator-walk" element={<Admin><AdminOperatorWalkPage /></Admin>} />
              <Route path="/admin/operator-walk/clients" element={<Admin><AdminOperatorWalkPage /></Admin>} />
              <Route path="/admin/operator-walk/reports" element={<Admin><AdminOperatorWalkPage /></Admin>} />
              <Route path="/admin/pricing" element={<Admin><AdminPricing /></Admin>} />
              <Route path="/admin/pricing/history" element={<Admin><AdminPricing /></Admin>} />
              <Route path="/admin/settings" element={<Admin><AdminSettings /></Admin>} />
              <Route path="/admin/content" element={<Admin><AdminContent /></Admin>} />

              {/* Operator Walk client portal */}
              <Route path="/portal/login" element={<PortalLogin />} />
              <Route path="/portal/forgot" element={<PortalForgot />} />
              <Route path="/portal/reset" element={<PortalReset />} />
              <Route
                path="/portal"
                element={
                  <PortalProtectedRoute>
                    <PortalDashboard />
                  </PortalProtectedRoute>
                }
              />

              {/* Public share landing (no auth) */}
              <Route path="/share/:token" element={<ShareReport />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ContentProvider>
          </PricingProvider>
        </PortalAuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        theme="light"
        toastOptions={{ style: { fontFamily: "'Outfit', sans-serif" } }}
      />
    </div>
  );
}

export default App;
